// Headless export registration for the Info-View histogram (single-output).
// The live iv Chart is reused as-is — it derives the vk-family chartModel from
// answer.hist/curve[period] and renders the shared vk Chart (D3). Key `histogram`
// is the legacy pptx.coffee dispatch key (Option A). The report-param `hg{key}`
// carries `{ period }` — the driver forwards it as params.period; the default
// mirrors legacy histogram.coffee importReportParams (format.bars, else bars[0]).
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/03b-nonhc-remainder.md §2

import {
  ExportableCharts,
  type ExportableChart
} from '@aytm/app/stats/page/question-views/components/charts/lib/exportable'

import HistogramChart from '@aytm/app/stats/page/question-views/info-view/components/charts/histogram/Chart'

const histogramEntry: ExportableChart = {
  Component: HistogramChart,
  toProps: (data: any, params: any) => {
    const bars = data.bars || []
    const period = String(params.period ?? data.format?.bars ?? bars[0] ?? '')

    return {
      id: data.id || data.questionKey,
      answer: data.answer,
      ticks: data.ticks,
      // Chart reads axis.x/axis.y without optional chaining — keep it an object.
      axis: data.axis || { x: '', y: '' },
      palette: data.palette || data.colorTheme,
      period,
      isAnimated: false,
      onExport: undefined
    }
  }
}

ExportableCharts.register('histogram', histogramEntry)
